(() => {
  const RUNTIME_NAME = 'MarineMaxProductOptions';
  const SECTION_SELECTOR = '[data-product-options]';
  const TEMPLATE_SELECTOR = '[data-product-options-template]';
  const GRID_SELECTOR = '[data-product-options-grid]';

  const existingRuntime = window[RUNTIME_NAME];
  if (existingRuntime?.initialize) {
    existingRuntime.initialize();
    return;
  }

  const normalizeText = (text) =>
    String(text || '')
      .replace(/\u00ad/g, '')
      .replace(/[\u200b-\u200d\ufeff]/g, '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const elementText = (element) => normalizeText(element?.textContent);

  const isList = (element) => element?.tagName === 'UL' || element?.tagName === 'OL';

  const hasMeaningfulListItems = (element) =>
    Array.from(element.querySelectorAll(':scope > li')).some((item) => elementText(item) !== '');

  const getSections = (root) => {
    if (!root) return [];

    const sections = [];
    if (typeof root.matches === 'function' && root.matches(SECTION_SELECTOR)) {
      sections.push(root);
    }
    if (typeof root.querySelectorAll === 'function') {
      sections.push(...root.querySelectorAll(SECTION_SELECTOR));
    }

    return [...new Set(sections)];
  };

  const initializeSection = (section) => {
    const template = section.querySelector(TEMPLATE_SELECTOR);
    const grid = section.querySelector(GRID_SELECTOR);

    if (!template?.content || !grid) return false;
    if (grid.childElementCount > 0) return true;

    const source = template.content.cloneNode(true);
    const sourceChildren = Array.from(source.children);
    const output = section.ownerDocument.createElement('div');

    const createGroup = (headingText) => {
      const group = section.ownerDocument.createElement('div');
      group.className = 'product-options__group';

      if (headingText) {
        const heading = section.ownerDocument.createElement('h3');
        heading.className = 'product-options__group-title';
        heading.textContent = headingText;
        group.appendChild(heading);
      }

      output.appendChild(group);
      return group;
    };

    const textLines = String(source.textContent || '')
      .split('\n')
      .map(normalizeText)
      .filter(Boolean);

    let currentGroup = null;

    if (!sourceChildren.length && textLines.length) {
      currentGroup = createGroup();
      textLines.forEach((line) => {
        const item = section.ownerDocument.createElement('p');
        item.className = 'product-options__item';
        item.textContent = line;
        currentGroup.appendChild(item);
      });
    }

    sourceChildren.forEach((element, index) => {
      const strong = element.querySelector('strong');
      const headingText = elementText(element);
      const isHeadingParagraph =
        element.tagName === 'P' && strong && headingText === normalizeText(strong.textContent);
      const isHeadingTag = /^H[2-6]$/.test(element.tagName);

      if (isList(element) && !hasMeaningfulListItems(element)) return;

      if (isHeadingParagraph || isHeadingTag) {
        currentGroup = createGroup(headingText);
        return;
      }

      if (!currentGroup) currentGroup = createGroup();

      const previousElement = sourceChildren[index - 1];
      const previousWasEmptyList =
        isList(previousElement) && !hasMeaningfulListItems(previousElement);

      if (element.tagName === 'P') {
        if (!headingText) return;

        const item = section.ownerDocument.createElement('p');
        item.className = 'product-options__item';
        item.innerHTML = element.innerHTML
          .replace(/\u00ad/g, '')
          .replace(/[\u200b-\u200d\ufeff]/g, '')
          .trim();
        currentGroup.appendChild(item);
        return;
      }

      const clone = element.cloneNode(true);
      clone.classList.add('product-options__item');
      if (previousWasEmptyList && isList(clone)) return;
      currentGroup.appendChild(clone);
    });

    const renderedGroups = Array.from(output.children);
    if (!renderedGroups.length) {
      section.remove();
      return false;
    }

    grid.replaceChildren(...renderedGroups);
    return true;
  };

  const initialize = (root = document) =>
    getSections(root).reduce(
      (initializedCount, section) => initializedCount + Number(initializeSection(section)),
      0,
    );

  const runtime = { initialize };
  window[RUNTIME_NAME] = runtime;

  const initializeDocument = () => initialize(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDocument, { once: true });
  } else {
    initializeDocument();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
